module.exports = __webpack_public_path__ + "static/media/certificate.5ec0e9a5.svg";